import {callsApi} from 'sources/api';
import TrendPivotChartActions from 'actions/calls/trend/TrendPivotChartActions';

const TrendPivotChartSource = {
  searchTrend: {
    remote(state, fields, interval, minDate, maxDate) {
      return callsApi.post(`/search/trend`, {
        fields: fields.toJS(),
        trend: true,
        interval: interval,
        min_date: minDate.format(),
        max_date: maxDate.format(),
      });
    },
    loading: TrendPivotChartActions.searchTrendLoading,
    success: TrendPivotChartActions.searchTrendSuccess,
    error: TrendPivotChartActions.searchTrendError,
  },

  searchPivot: {
    remote(state, fields, interval, minDate, maxDate) {
      return callsApi.post(`/search/trend`, {
        fields: fields.toObject(),
        trend: true,
        interval: interval,
        min_date: minDate.format(),
        max_date: maxDate.format(),
      });
    },
    loading: TrendPivotChartActions.searchPivotLoading,
    success: TrendPivotChartActions.searchPivotSuccess,
    error: TrendPivotChartActions.searchPivotError,
  },
};

export default TrendPivotChartSource;
